.prose {
  font-size: 13px;
  color: var(--black);
  white-space: pre-wrap;
  margin: 5px 0;
}

.code {
  font-size: 12px;
  border-radius: 4px;
  border: solid 1px var(--very-light-pink);
}

.diff {
  margin: 5px 0;
  padding: 8px 0;
  font-size: 12px;
  line-height: 1.5;
  background-color: var(--fully-white);
  border: solid 1px var(--very-light-pink);
  border-radius: 4px;
  overflow-x: auto;
}

.diff div {
  padding: 0 10px;
  white-space: pre;
}

/* GitHub-style diff backgrounds — no design token comes close to these pale shades */
.diffAdded {
  background-color: #dafbe1;
}

.diffRemoved {
  background-color: #ffebe9;
}

.diffContext {
  color: var(--black);
}

.codeWrap {
  position: relative;
}

.copyCorner {
  position: absolute;
  top: 2px;
  right: 8px;
  z-index: 1;
}
